import React, { useEffect, useState } from "react";
import style from "./Login.module.css";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../hook/userAuth";
import { BASE_API } from "../../ruta-server/BaseApi";
import BotonColor from "../../components/BotonColor/BotonColor.js";
import HeaderSmall from "../../components/HeaderSmall/HeaderSmall.js";

export default function Login() {
  const navigate = useNavigate();
  const { login, auth } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: Yup.object(validationSchema()),
    onSubmit: async (formValues) => {
      try {
        const response = await axios.post(`${BASE_API}/api/auth/login/`, {
          username: formValues.username,
          password: formValues.password,
        });

        const { access } = response.data;
        login(access);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("Usuario o contraseña incorrectos");
        } else {
          toast.error("Se produjo un error. Por favor, inténtalo de nuevo.");
        }
      }
    },
  });

  useEffect(() => {
    if (auth) {
      navigate("/");
    }
  }, [auth, navigate]);
  return (
    <div className={style.contenedor}>
      <div className={style.rectangulo}>
        <HeaderSmall btTitulo="Ingresa" />
        <div className={style.recder}>
          <Form className={style.loginStyle} onSubmit={formik.handleSubmit}>
            <Form.Input
              name="username"
              placeholder="Nombre de usuario"
              className={style.inform}
              value={formik.values.username}
              onChange={formik.handleChange}
              error={formik.errors.username}
            />
            <Form.Input
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña"
              className={style.inform}
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.errors.password}
              icon={{
                name: showPassword ? "eye" : "eye slash",
                link: true,
                onClick: () => setShowPassword(!showPassword),
              }}
            />
            <BotonColor type="submit" btnTitulo="Iniciar sesión" />
          </Form>

          <Link to="/password-reset" className={style.linkf}>
            ¿Olvidaste tu contraseña?
          </Link>
          <ToastContainer
            position="bottom-center"
            autoClose={1500}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
          />
        </div>
      </div>
    </div>
  );
}

function initialValues() {
  return {
    username: "",
    password: "",
  };
}

function validationSchema() {
  return {
    username: Yup.string().required(true),
    password: Yup.string().required(true),
  };
}
